import createApi from "../utils/axiosInstance";

export const getAllQuestions = async (page, limit) => {
  try {
    const api = createApi(true);
    const response = await api.get(
      `/admin/user/requests?page=${page}&limit=${limit}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Getting question data failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const updateStatus = async (status, questionId) => {
  try {
    const api = createApi(true);
    const response = await api.post(
      `/admin/user/request/${questionId}/status`,
      { status }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Update  failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const addReplyToQuestionApi = async ({ questionId, reply }) => {
  try {
    const api = createApi(true);
    const response = await api.put(`/admin/user/request/${questionId}/reply`, { reply });
    return response.data;
  } catch (error) {
    console.error(
      "addReplyToQuestion failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error.message;
  }
};
export const addThreadedReplyToQuestionApi = async ({ questionId, message }) => {
  try {
    const api = createApi(true);
    const response = await api.post(`/admin/user/requests/${questionId}/threaded-reply`, { message });
    return response.data;
  } catch (error) {
    console.error(
      "addThreadedReplyToQuestionApi failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error.message;
  }
};

export const deleteReplyToQuestionApi = async ({ questionId }) => {
  try {
    const api = createApi(true);
    const response = await api.delete(`/admin/user/requests/${questionId}/reply`);
    return response.data;
  } catch (error) {
    console.error(
      "deleteReplyToQuestion failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error.message;
  }
};
export const deleteThreadedReplyToQuestionApi = async ({ questionId, replyId }) => {
  try {
    const api = createApi(true);
    const response = await api.delete(`/admin/user/requests/${questionId}/threaded/${replyId}`);
    return response.data;
  } catch (error) {
    console.error(
      "deleteThreadedReplyToQuestionApi failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error.message;
  }
};

export const editThreadedReplyToQuestionApi = async ({ questionId, replyId, message }) => {
  try {
    const api = createApi(true);
    const response = await api.put(`/admin/user/requests/${questionId}/threaded-reply`, { replyId, message });
    return response.data;
  } catch (error) {
    console.error(
      "editThreadedReplyToQuestionApi failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error.message;
  }
};
